import { Colors, Services } from '@sigma-frontend-libs/commons'

import { eventsHistoryColors, eventsHistoryIcons, icons, permissionPresets } from '@/utils'

import buttonEdit from '@/components/services/eventsHistory/item/buttons/edit'
import sticker from '@/components/sticker'
import date from '@/components/templates/service/item/date'
import owner from '@/components/templates/service/item/owner'

function renderService(h) {
  return h(
    sticker,
    {
      props: {
        value: this.getTranslate(`${Services.eventsHistory}.services.${this.service.title}`),
        label: this.getTranslate(`${Services.eventsHistory}.types.${this.value.type}`),
        icon: eventsHistoryIcons[this.value.type],
        iconTooltip: this.getTranslate(`${Services.eventsHistory}.types.${this.value.type}`),
        color: eventsHistoryColors[this.value.type],
        to: {
          name: this.service.name,
          params: this.toParamsForServiceSticker,
          query: { currentTab: this.service.currentTab }
        }
      }
    }
  )
}
function renderUser(h) {
  if (this.viewport.size.width > 500) {
    return h(
      owner,
      {
        props: {
          value: this.value,
          pathToData: 'User',
          label: this.getTranslate(`${Services.eventsHistory}.labels.author`)
        }
      }
    )
  }
}
function renderInfo(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.eventsHistory}-item__info`]: true,
        [`${Services.eventsHistory}-item__info--admin`]: this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
      }
    },
    [
      renderService.call(this, h),
      renderUser.call(this, h)
    ]
  )
}

function renderEntityId(h) {
  if (this.viewport.size.width > 1280) {
    if (this.service.entityId) {
      return h(
        sticker,
        {
          props: {
            value: { entityId: this.service.entityId },
            label: this.getTranslate(`${Services.eventsHistory}.labels.id`),
            icon: icons.numbers,
            color: Colors.grey,
            pathToTitle: 'entityId',
            to: this.computedTo,
            width: 'fit-content'
          }
        }
      )
    }
  }
}

function renderButtons(h) {
  return h(
    'div',
    {
      class: {
        [`${Services.eventsHistory}-item__buttons`]: true,
        'hover-child': this.viewport.breakpoint.mdUp
      }
    },
    [
      h(
        buttonEdit,
        {
          props: {
            id: this.value.id
          }
        }
      )
    ]
  )
}

function renderCreatedAt(h) {
  return h(
    date,
    {
      props: {
        value: this.value
      }
    }
  )
}

export default function(h) {
  return h(
    'div',
    {
      class: {
        'service-template-item': true,
        [`${Services.eventsHistory}-item`]: true,
        [`${Services.eventsHistory}-item--id`]: !!this.service.entityId,
        'hover-parent hover-parent--opacity': this.viewport.breakpoint.mdUp
      }
    },
    [
      renderInfo.call(this, h),
      renderEntityId.call(this, h),
      renderButtons.call(this, h),
      renderCreatedAt.call(this, h)
    ]
  )
}
